"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidTransferMedName = exports.isValidPharmacyName = exports.isValidZipCode = exports.isValidCity = exports.isValidStreet = exports.isValidEmail = exports.isValidFirstOrLastName = exports.parseStringifiedReminder = exports.stringifyReminder = exports.sortAppointmentTypes = exports.getPharmOpenHours = exports.getDateWithUTCOffset = exports.formatOpenCloseHours = exports.hasDistinctCharacters = exports.getAvailableTimes = exports.isFillOnHold = exports.formatPrice = exports.formatPrescriptionNumber = exports.formatPhoneNumber = void 0;
var date_fns_1 = require("date-fns");
function formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.replace(/\D/g, "");
    if (phoneNumber.length >= 10) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }
    else if (phoneNumber.length >= 7) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d*)/, "($1) $2-$3");
    }
    else if (phoneNumber.length >= 4) {
        return phoneNumber.replace(/(\d{3})(\d*)/, "($1) $2");
    }
    return phoneNumber;
}
exports.formatPhoneNumber = formatPhoneNumber;
function formatPrescriptionNumber(prescriptionNumber) {
    prescriptionNumber = prescriptionNumber.replace(/\D/g, "");
    return prescriptionNumber;
}
exports.formatPrescriptionNumber = formatPrescriptionNumber;
function formatPrice(price) {
    var absValue = Math.abs(price);
    var formatted = absValue.toFixed(2);
    return price >= 0 ? "$".concat(formatted) : "($".concat(formatted, ")");
}
exports.formatPrice = formatPrice;
function isFillOnHold(fill) {
    return (fill === null || fill === void 0 ? void 0 : fill.dispenseDate) === null || (fill === null || fill === void 0 ? void 0 : fill.dispenseDate) === undefined;
}
exports.isFillOnHold = isFillOnHold;
var WEEKDAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
var WEEKDAYS_SPANISH = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
];
var getDayFromDate = function (selectedDate) {
    var dayCode = selectedDate.getDay();
    return [WEEKDAYS[dayCode], WEEKDAYS_SPANISH[dayCode]];
};
function minutesToTimeString(minutes) {
    var formattedHours = Math.floor(minutes / 60)
        .toString()
        .padStart(2, "0");
    var formattedMinutes = (minutes % 60).toString().padStart(2, "0");
    return "".concat(formattedHours, ":").concat(formattedMinutes);
}
function getTimes(openTime, closeTime, interval) {
    var openHour = Number(openTime.slice(0, 2));
    var openMinutes = Number(openTime.slice(3, 5));
    var closeHour = Number(closeTime.slice(0, 2));
    var closeMinutes = Number(closeTime.slice(3, 5));
    var openTotal = openHour * 60 + openMinutes;
    var closeTotal = closeHour * 60 + closeMinutes;
    var times = [];
    for (var currTimeTotal = openTotal; currTimeTotal + interval <= closeTotal; currTimeTotal += interval) {
        times.push(minutesToTimeString(currTimeTotal));
    }
    return times;
}
function addMinutesToTime(time, minutes) {
    var _a = time.split(":"), hoursStr = _a[0], minutesStr = _a[1];
    var parsedHours = parseInt(hoursStr);
    var parsedMinutes = parseInt(minutesStr);
    return minutesToTimeString(parsedHours * 60 + parsedMinutes + minutes);
}
function convertToNextHalfHourInterval(dateToConvert) {
    var currentMinutes = dateToConvert.getMinutes();
    if (currentMinutes === 0 || currentMinutes === 30) {
        return dateToConvert;
    }
    var minutesToAdd = currentMinutes < 30 ? 30 - currentMinutes : 60 - currentMinutes;
    return (0, date_fns_1.add)(dateToConvert, { minutes: minutesToAdd });
}
function getDifferenceInMinutesBasedOnPharmacyHours(now, selectedDayWithOpenTime, pharmacyHours) {
    var iterationDate = now;
    var diffInMinutes = 0;
    while ((0, date_fns_1.isBefore)(iterationDate, selectedDayWithOpenTime)) {
        var iterationDateHours = pharmacyHours.find(function (listedDay) {
            var _a = getDayFromDate(iterationDate), day = _a[0], daySpanish = _a[1];
            return listedDay.day === day || listedDay.day === daySpanish;
        });
        if (!iterationDateHours) {
            iterationDate = (0, date_fns_1.addDays)(iterationDate, 1);
            continue;
        }
        var iterationDateWithCloseTime = (0, date_fns_1.parse)(iterationDateHours.close, "HH:mm:ss", iterationDate);
        if ((0, date_fns_1.isAfter)(now, iterationDateWithCloseTime)) {
            iterationDate = (0, date_fns_1.addDays)(iterationDate, 1);
            continue;
        }
        var iterationDateWithOpenTime = (0, date_fns_1.parse)(iterationDateHours.open, "HH:mm:ss", iterationDate);
        var startTime = (0, date_fns_1.isAfter)(now, iterationDateWithOpenTime)
            ? now
            : iterationDateWithOpenTime;
        diffInMinutes += (0, date_fns_1.differenceInMinutes)(iterationDateWithCloseTime, startTime);
        iterationDate = (0, date_fns_1.addDays)(iterationDate, 1);
    }
    return diffInMinutes;
}
function getAvailableTimes(date, pharmacyHours, leadBufferMinutes, closingBufferMinutes) {
    if (leadBufferMinutes === void 0) { leadBufferMinutes = 0; }
    if (closingBufferMinutes === void 0) { closingBufferMinutes = 0; }
    if (!pharmacyHours) {
        return [];
    }
    var _a = getDayFromDate(date), day = _a[0], daySpanish = _a[1];
    var selectedDays = pharmacyHours.filter(function (d) { return d.day === day || d.day === daySpanish; });
    var invalidDays = selectedDays.filter(function (d) { return d.open > d.close; });
    if (!selectedDays.length || invalidDays.length) {
        return [];
    }
    var times = [];
    for (var i = 0; i < selectedDays.length; i++) {
        var selectedDay = selectedDays[i];
        var open = selectedDay.open;
        var now = new Date();
        var nextHalfHourIntervalAfterNow = convertToNextHalfHourInterval(now);
        var remainingLeadBufferMinutes = leadBufferMinutes;
        if ((0, date_fns_1.isSameDay)(date, now)) {
            open = (0, date_fns_1.format)(nextHalfHourIntervalAfterNow, "HH:mm");
        }
        else {
            var selectedDayWithOpenTime = (0, date_fns_1.parse)(selectedDay.open, "HH:mm:ss", date);
            var minutesPassedBetweenNowAndSelectedDateOpenTime = getDifferenceInMinutesBasedOnPharmacyHours(now, selectedDayWithOpenTime, pharmacyHours);
            remainingLeadBufferMinutes =
                remainingLeadBufferMinutes >
                    minutesPassedBetweenNowAndSelectedDateOpenTime
                    ? remainingLeadBufferMinutes -
                        minutesPassedBetweenNowAndSelectedDateOpenTime
                    : 0;
        }
        var intervalMinutes = 30;
        var openBuffer = Math.ceil(remainingLeadBufferMinutes / intervalMinutes) * intervalMinutes;
        var closeBuffer = Math.ceil(closingBufferMinutes / intervalMinutes) * intervalMinutes;
        var newTimes = getTimes(addMinutesToTime(open, openBuffer), addMinutesToTime(selectedDay.close, -closeBuffer), intervalMinutes);
        times.push.apply(times, newTimes);
    }
    return times;
}
exports.getAvailableTimes = getAvailableTimes;
// android doesn't support negtive lookbehinds in regex
function hasDistinctCharacters(minNumDistinctChars, str) {
    if (str.length < minNumDistinctChars) {
        return false;
    }
    var uniqueChars = 0;
    var letters = {};
    var i = 0;
    while (uniqueChars < minNumDistinctChars && i < str.length) {
        var letter = str[i];
        if (!letters[letter]) {
            letters[letter] = true;
            uniqueChars++;
        }
        i++;
    }
    return uniqueChars >= minNumDistinctChars;
}
exports.hasDistinctCharacters = hasDistinctCharacters;
function formatOpenCloseHours(openTime, closeTime) {
    var openTimeDate = (0, date_fns_1.parse)(openTime, "HH:mm:ss", new Date());
    var closeTimeDate = (0, date_fns_1.parse)(closeTime, "HH:mm:ss", new Date());
    var formattedHourStr = "".concat((0, date_fns_1.format)(openTimeDate, "p"), "-").concat((0, date_fns_1.format)(closeTimeDate, "p")).toLowerCase();
    var pattern = /(:00)|(\s)/g;
    return formattedHourStr.replace(pattern, "");
}
exports.formatOpenCloseHours = formatOpenCloseHours;
function getDateWithUTCOffset(now, baseUtcOffset) {
    var _a = baseUtcOffset.split(":"), hours = _a[0], minutes = _a[1], seconds = _a[2];
    // The minutes/seconds components must carry the same sign as the offset, so a
    // negative offset like "-05:30:00" resolves to -5.5h (not -4.5h). Derive the
    // sign from the raw string because parseInt("-00") loses the sign for "-00:30".
    var sign = hours.trim().startsWith("-") ? -1 : 1;
    var inputTzOffset = parseInt(hours) +
        (sign * parseInt(minutes || "0")) / 60 +
        (sign * parseInt(seconds || "0")) / (60 * 60);
    var currentTzOffset = -now.getTimezoneOffset() / 60; // in hours, i.e. -4 in NY
    var deltaTzOffset = inputTzOffset - currentTzOffset; // timezone diff
    var nowTimestamp = now.getTime(); // get the number of milliseconds since unix epoch
    var deltaTzOffsetMilli = deltaTzOffset * 1000 * 60 * 60; // convert hours to milliseconds (tzOffsetMilli*1000*60*60)
    var outputDate = new Date(nowTimestamp + deltaTzOffsetMilli); // your new Date object with the timezone offset applied.
    return outputDate;
}
exports.getDateWithUTCOffset = getDateWithUTCOffset;
function getPharmOpenHours(now, hours, baseUtcOffset) {
    var nowDayOfWeek = getDateWithUTCOffset(now, baseUtcOffset);
    var currentDayIndex = nowDayOfWeek.getDay();
    var weekDay = WEEKDAYS[currentDayIndex];
    var weekDaySpanish = WEEKDAYS_SPANISH[currentDayIndex];
    var hoursMatchingDay = hours.filter(function (h) { return h.day === weekDay || h.day === weekDaySpanish; });
    if (hoursMatchingDay.length === 0) {
        return { isOpen: false, currentlyOpenHours: null };
    }
    for (var i = 0; i < hoursMatchingDay.length; i++) {
        var offsetPrefix = baseUtcOffset.charAt(0) === "-" || baseUtcOffset.charAt(0) === "+"
            ? ""
            : "+";
        var openingDate = (0, date_fns_1.parse)(hoursMatchingDay[i].open + offsetPrefix + baseUtcOffset, "HH:mm:ssxxxxx", nowDayOfWeek);
        var closingDate = (0, date_fns_1.parse)(hoursMatchingDay[i].close + offsetPrefix + baseUtcOffset, "HH:mm:ssxxxxx", nowDayOfWeek);
        var isOpen = ((0, date_fns_1.isAfter)(now, openingDate) || (0, date_fns_1.isEqual)(now, openingDate)) &&
            ((0, date_fns_1.isBefore)(now, closingDate) || (0, date_fns_1.isEqual)(now, closingDate));
        if (isOpen) {
            return {
                isOpen: true,
                currentlyOpenHours: formatOpenCloseHours(hoursMatchingDay[i].open, hoursMatchingDay[i].close),
            };
        }
    }
    return { isOpen: false, currentlyOpenHours: null };
}
exports.getPharmOpenHours = getPharmOpenHours;
function sortAppointmentTypes(selectableAppointmentTypes) {
    // sort appt types so it's always [vaccination, test, consultation]
    return __spreadArray([], selectableAppointmentTypes, true).sort(function (a, b) {
        if (a === "Vaccination" || a === "Vacunación") {
            return -1;
        }
        else if (a === "Consultation" || a === "Consulta") {
            return 1;
        }
        else if ((a === "Test" || a === "Examen") &&
            (b === "Vaccination" || b === "Vacunación")) {
            return 1;
        }
        else if ((a === "Test" || a === "Examen") &&
            (b === "Consultation" || b === "Consulta")) {
            return -1;
        }
        else {
            return 0;
        }
    });
}
exports.sortAppointmentTypes = sortAppointmentTypes;
function stringifyReminder(reminder) {
    return __assign(__assign({}, reminder), { endDate: reminder.endDate ? (0, date_fns_1.formatISO)(reminder.endDate) : null, startDate: (0, date_fns_1.formatISO)(reminder.startDate), dailyInfo: reminder.dailyInfo.map(function (di) { return (__assign(__assign({}, di), { time: (0, date_fns_1.formatISO)(di.time) })); }) });
}
exports.stringifyReminder = stringifyReminder;
function parseStringifiedReminder(reminder) {
    return __assign(__assign({}, reminder), { endDate: reminder.endDate ? (0, date_fns_1.parseISO)(reminder.endDate) : null, startDate: (0, date_fns_1.parseISO)(reminder.startDate), dailyInfo: reminder.dailyInfo.map(function (di) { return (__assign(__assign({}, di), { time: (0, date_fns_1.parseISO)(di.time) })); }) });
}
exports.parseStringifiedReminder = parseStringifiedReminder;
function isValidFirstOrLastName(name) {
    var regex = /[:;\\\/@#$%*]+/;
    return !regex.test(name);
}
exports.isValidFirstOrLastName = isValidFirstOrLastName;
function isValidEmail(email) {
    var regex = /[:;]+/;
    return !regex.test(email);
}
exports.isValidEmail = isValidEmail;
// Anchored at the start (^) so the match must span the whole string — the
// previous unanchored form relied on a fragile suffix-equality trick and left
// the null-exec fallback unreachable (dead code). Still compares the match to
// the input (rather than .test) so a string with a trailing newline is rejected
// exactly as before. Behavior is unchanged: valid iff every char is allowed.
function isValidStreet(street) {
    var _a;
    return ((_a = /^[a-zA-Z0-9 \-.#,'&()/]*$/.exec(street)) === null || _a === void 0 ? void 0 : _a[0]) === street;
}
exports.isValidStreet = isValidStreet;
function isValidCity(city) {
    var _a;
    return ((_a = /^[a-zA-Z0-9 \-.,'&()]*$/.exec(city)) === null || _a === void 0 ? void 0 : _a[0]) === city;
}
exports.isValidCity = isValidCity;
function isValidZipCode(zip) {
    var _a;
    return ((_a = /^[a-zA-Z0-9 \-]*$/.exec(zip)) === null || _a === void 0 ? void 0 : _a[0]) === zip;
}
exports.isValidZipCode = isValidZipCode;
function isValidPharmacyName(name) {
    var regex = /[:;\\$%*]+/;
    return !regex.test(name);
}
exports.isValidPharmacyName = isValidPharmacyName;
function isValidTransferMedName(name) {
    var regex = /[:;]+/;
    return !regex.test(name);
}
exports.isValidTransferMedName = isValidTransferMedName;
